import React from 'react';

import { Outlet } from 'react-router-dom';
const EtcMngPage = () => {
  return <Outlet />;
};

export default EtcMngPage;
